<div class="flex flex-col gap-4">
  <h1 class="text-center">{{ title }}</h1>

  @if (dataURL) {
    <object [attr.data]="dataURL" class="w-full h-screen" [attr.aria-label]="title + '-PDF-Vorschau'"></object>
    <div class="flex flex-row items-center gap-1">
      <p-checkbox [formControl]="control" binary="true" [inputId]="title" />
      <label [for]="title">Hiermit bestätige ich, dass ich die {{ title }} zur Kenntnis genommen habe und diese akzeptiere.</label>
    </div>
    @if (stateService.getHasError()) {
      <taures-message severity="error" header="Fehler">{{ title }} konnte nicht bestätigt werden. </taures-message>
    }
    <div class="flex justify-end">
      <p-button
        type="button"
        (click)="accept()"
        [loading]="stateService.getIsLoading()"
        [disabled]="stateService.getIsLoading() || control.invalid"
        label="Weiter"
      />
    </div>
  } @else {
    <p-skeleton width="100%" height="100%" class="w-full h-screen"></p-skeleton>
    <div class="flex flex-col gap-2">
      <div class="flex flex-row gap-1">
        <p-skeleton width="20px" height="20px" class="flex-none w-5 h-5"></p-skeleton>
        <p-skeleton height="20px" class="flex-1 h-5"></p-skeleton>
      </div>
      <p-skeleton height="30px"></p-skeleton>
    </div>
  }
</div>
